var _path, _circle, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAirlineTransfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.267,16.286l-1.193-.64c-.773-.415-1.636-.632-2.513-.632h-9.103s-9.365-7.334-9.365-7.334h-4.228s6.434,7.334,6.434,7.334h-9.192s-2.501-2.273-2.501-2.273h-2.118s2.105,5.075,2.105,5.075c.487,1.175,1.635,1.942,2.907,1.942h24.224c1.441,0,2.875-.21,4.255-.624h0c1.322-.396,1.504-2.194.288-2.847Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.29,
    cy: 30.779,
    r: 3.542
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.327,
    y1: 30.779,
    x2: 14.749,
    y2: 30.779
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.832,
    y1: 30.779,
    x2: 24.332,
    y2: 30.779
  })), /*#__PURE__*/React.createElement("line", {
    x1: 28.279,
    y1: 30.779,
    x2: 34.2,
    y2: 30.779,
    style: {
      strokeDasharray: "0 0 3.947 3.947"
    }
  }), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36.173,
    y1: 30.779,
    x2: 38.673,
    y2: 30.779
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAirlineTransfers);
export default __webpack_public_path__ + "static/media/indoor-airline_transfers.fd383c93a255932a39b0c0b6fdeb1461.svg";
export { ForwardRef as ReactComponent };